module.exports = __webpack_public_path__ + "img/linknau-w-tag.f85554ad.png";